import axios from 'axios';
import Cleave from 'cleave.js'
import 'cleave.js/dist/addons/cleave-phone.br';

import { Controller } from '@hotwired/stimulus';
import { application } from 'src/app';
import {
  hideElement,
  displayElement,
  displayElementIfIsNotVisible,
  hideElementIfIsVisibe,
  find,
  findAll,
  addClass,
  removeClass,
  hasClass,
  getParent,
  elementValueIfEnabled,
  enableElement,
  disableElement
} from '@fretadao/f-js-dom';
import './component.scss';

application.register('business-contact-form', class extends Controller {
  static classes = ['active'];
  static targets = ['businessOptions', 'passengerOptions', 'otherOptionField', 'form', 'submitButton'];

  radioButtonList = findAll('input[type="radio"]', this.element);

  nextPage(event, element = undefined) {
    let targetElement = element === undefined ? event : element;

    if (event) {
      targetElement = targetElement.target;
      event.preventDefault();
    }

    const currentPage = element === undefined ? getParent(targetElement, 2) : element;
    const currentPageIndex = parseInt(currentPage.dataset.pageIndex);
    const newPageIndex = (currentPageIndex + 1) % 3;
    const newPageEl = find(`[data-page-index="${newPageIndex}"]`);

    hideElement(currentPage);
    displayElement(newPageEl);
  }

  highlightOption(event) {
    const inputChecked = event.target;
    const inputUnchecked = this.radioButtonList.find((input => input != inputChecked));
    const inputContainer = inputChecked.parentElement;
    const radioFields = this.radioButtonList.map((input) => input.parentElement);

    radioFields.forEach(field => removeClass(field, this.activeClass));
    addClass(inputContainer, this.activeClass);
    this.toggleOptionButton(inputChecked.getAttribute('value'), inputUnchecked.getAttribute('value'));
  }

  toggleOptionButton(target1, target2) {
    if (hasClass(this[`${target2}OptionsTarget`], 'd-hidden')) {
      removeClass(this[`${target1}OptionsTarget`], 'd-hidden');
    } else {
      addClass(this[`${target2}OptionsTarget`], 'd-hidden');
      removeClass(this[`${target1}OptionsTarget`], 'd-hidden');
    }
  }
})
